<template>
  <main class="page question-app">
    <ncc-question-header/>
    <ncc-question-option-bar/>
    <ncc-question-toolbar/>
    <ncc-question-video-bar/>
    <ncc-question-prayer-bar/>
    <ncc-question-comment-bar/>
  </main>
</template>

<script>
    import NccQuestionHeader from "./NccQuestionHeader";
    import NccQuestionOptionBar from "./NccQuestionOptionBar";
    import NccQuestionToolbar from "./NccQuestionToolbar";
    import NccQuestionVideoBar from "./NccQuestionVideoBar";
    import NccQuestionPrayerBar from "./NccQuestionPrayerBar";
    import NccQuestionCommentBar from "./NccQuestionCommentBar";

    export default {
        components: {
            NccQuestionPrayerBar,
            NccQuestionVideoBar,
            NccQuestionToolbar,
            NccQuestionOptionBar,
            NccQuestionHeader,
            NccQuestionCommentBar
        }
    }
</script>
